// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationMeta } from './PaginationMeta';
import {
    PaginationMetaFromJSON,
    PaginationMetaFromJSONTyped,
    PaginationMetaToJSON,
    PaginationMetaToJSONTyped,
} from './PaginationMeta';
import type { IncidentQueryMeta } from './IncidentQueryMeta';
import {
    IncidentQueryMetaFromJSON,
    IncidentQueryMetaFromJSONTyped,
    IncidentQueryMetaToJSON,
    IncidentQueryMetaToJSONTyped,
} from './IncidentQueryMeta';

/**
 * 
 * @export
 * @interface IncidentQueryResponseMeta
 */
export interface IncidentQueryResponseMeta {
    /**
     * 
     */
    items: PaginationMeta;
    /**
     * 
     */
    query: IncidentQueryMeta;
}

/**
 * Check if a given object implements the IncidentQueryResponseMeta interface.
 */
export function instanceOfIncidentQueryResponseMeta(value: object): value is IncidentQueryResponseMeta {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function IncidentQueryResponseMetaFromJSON(json: any): IncidentQueryResponseMeta {
    return IncidentQueryResponseMetaFromJSONTyped(json, false);
}

export function IncidentQueryResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentQueryResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'items': PaginationMetaFromJSON(json['items']),
        'query': IncidentQueryMetaFromJSON(json['query']),
    };
}

export function IncidentQueryResponseMetaToJSON(json: any): IncidentQueryResponseMeta {
    return IncidentQueryResponseMetaToJSONTyped(json, false);
}

export function IncidentQueryResponseMetaToJSONTyped(value?: IncidentQueryResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': PaginationMetaToJSON(value['items']),
        'query': IncidentQueryMetaToJSON(value['query']),
    };
}

